/* eslint no-undef: 'off' */
import $ from "jquery";

const el = {
  button: ".ReturnOldCar__Button__Submit",
  attributes: ".Autogegevens__Form__Select select",
  url_image: "#url_image",
  user_data: {
    fullname: "#fullname",
    email: "#email",
    phone_number: "#telefoonummer",
    code_contry: "#select2-countryCode-container",
    price_expectation: "#price-expectation",
    land: "#land",
    city: "#stad",
    address: "#address",
    note: "#opmerking",
  },
};

const ajax_send_email = () => {
  $(document).on("click", el.button, (e) => {
    e.preventDefault();
    const attributes = get_attributes();
    const user_data = get_user_data();
    const url_image = $(el.url_image).val();
    const ajax = themeObj.ajax_handle_return_car;

    let data = {
      nonce: ajax.nonce,
      action: ajax.action,
      attributes: attributes,
      user_data: user_data,
      url_image: url_image,
    };

    $.ajax({
      type: "POST",
      url: themeObj.ajaxUrl,
      data: data,
    }).done((res) => {
      if (res.success) {
        alert(res.data.message);
        location.href = res.data.redirect_to;
      } else {
        alert(res.data.message);
      }
    });
  });
};

const get_attributes = () => {
  let selectedValues = {};

  $(el.attributes).each(function () {
    let selectedOption = $(this).find("option:selected");
    if (selectedOption.length > 0) {
      const label = $(this).prev("label").text().trim().replace(/\*/g, "");
      const selectedValue = $(this).val();
      selectedValues[label] = selectedValue;
    }
  });
  return selectedValues;
};

const get_user_data = () => {
  const code_contry = $(el.user_data.code_contry).text();
  const phone_number = get_value(el.user_data.phone_number);
  const phone_number_with_code = code_contry + " " + phone_number;
  const user_data = {
    fullname: get_value(el.user_data.fullname),
    email: get_value(el.user_data.email),
    phone_number: phone_number_with_code,
    price_expectation: get_value(el.user_data.price_expectation),
    land: get_value(el.user_data.land),
    city: get_value(el.user_data.city),
    address: get_value(el.user_data.address),
    note: get_value(el.user_data.note),
  };
  return user_data;
};

const get_value = (element) => {
  const value = $(element).val();
  return value !== undefined && value !== null ? value : "";
};

const init = () => {
  ajax_send_email();
};
try {
  init();
} catch (error) {
  console.error(`This File Error ${error}`);
}
